import { LeadsysPictureDto } from '../http/dto/leadsys-picture-dto.interface';
import { LeadsysPicture } from '../interfaces/leadsys-picture.interface';

export const mapLeadsysPictureDtosToLeadsysPictures = (leadsysPictureDtos: readonly LeadsysPictureDto[]): LeadsysPicture[] =>
  leadsysPictureDtos.map((leadsysPictureDto: LeadsysPictureDto) => ({
    ...leadsysPictureDto,
    createdAt: new Date(leadsysPictureDto.createdAt),
  }));
